export function EmptyState({ title, subtitle, action }) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center" data-testid="empty-state">
      <img
        src="https://images.unsplash.com/photo-1646614871839-881108ea8407?crop=entropy&cs=srgb&fm=jpg&w=400&q=80"
        alt=""
        className="mb-6 h-32 w-32 rounded-3xl object-cover opacity-90"
      />
      <h3 className="text-xl font-medium text-[#1D1D1F]">{title}</h3>
      {subtitle && <p className="mt-2 max-w-sm text-sm text-[#86868B]">{subtitle}</p>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
